import { Link } from 'react-router-dom'
import { SignedIn, SignedOut } from '@clerk/clerk-react'

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <nav className="bg-white border-b border-gray-200 py-4">
        <div className="max-w-7xl mx-auto px-6">
          <Link to="/" className="text-2xl font-bold tracking-tight text-navy">
            STEADFAST <span className="text-gold">HSA</span>
          </Link>
        </div>
      </nav>

      {/* 404 Content */}
      <div className="flex-1 flex items-center justify-center px-6 py-20">
        <div className="text-center max-w-md">
          <div className="text-8xl font-black text-navy mb-2">404</div>
          <div className="h-1 w-16 bg-gold rounded-full mx-auto mb-8" />
          <h1 className="text-2xl font-bold text-navy mb-4">Page not found</h1>
          <p className="text-slate-500 mb-10 leading-relaxed">
            We couldn't find the page you were looking for. It may have been moved or doesn't exist.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <SignedIn>
              <Link
                to="/dashboard"
                className="bg-navy text-white px-6 py-3 rounded-lg font-bold hover:opacity-90 transition"
              >
                Go to Dashboard
              </Link>
            </SignedIn>
            <Link
              to="/"
              className="border border-gray-300 text-navy px-6 py-3 rounded-lg font-bold hover:border-navy transition"
            >
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
